<span class="breadcrumb-item d-flex mb-2" [class.is--last]="isLast">
    <a routerLink="{{ breadcrumb.url }}" (click)="onBreadcrumbClick()" [style.background-color]="getProgressBarColor()">
        <span [innerHTML]="breadcrumb.name | translate | safeStyle"></span>
        <ng-template [otbShowInEnv]="['default', 'sh', 'finance', 'justice', 'hmdj', 'bb-jm']">
            @if (!isLast) {
                <fa-icon class="fa" [icon]="faEdit"></fa-icon>
            }
        </ng-template>
    </a>
</span>
